import { render, staticRenderFns } from "./AdminSettings.vue?vue&type=template&id=7d2977e1&"
import script from "./AdminSettings.vue?vue&type=script&lang=js&"
export * from "./AdminSettings.vue?vue&type=script&lang=js&"
import style0 from "./AdminSettings.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports